import React, { useEffect, useState } from 'react';
import { Button, Form, Header, Image, Message, Segment } from 'semantic-ui-react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { API, getLogo, getSystemName, showError, showInfo, showSuccess } from '../helpers';
import PolicyLinks from './PolicyLinks';

const RegisterForm = () => {
  const [inputs, setInputs] = useState({
    username: '',
    password: '',
    password2: '',
    email: '',
    verification_code: '',
    aff_code: ''
  });
  const { username, password, password2, email, verification_code, aff_code } = inputs;
  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [loading, setLoading] = useState(false);
  const logo = getLogo();
  const systemName = getSystemName();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let status = localStorage.getItem('status');
    if (status) {
      status = JSON.parse(status);
      setShowEmailVerification(status.email_verification);
    }
  }, []);

  useEffect(() => {
    const referralCode = searchParams.get('aff') || searchParams.get('aff_code');
    if (referralCode) {
      setInputs((current) => ({ ...current, aff_code: referralCode.trim() }));
    }
  }, [searchParams]);

  function handleChange(e) {
    const { name, value } = e.target;
    setInputs((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }
    if (!username || !password || !password2) {
      showInfo('请完整填写注册信息');
      return;
    }
    if (password.length < 8) {
      showInfo('密码长度不得小于 8 位！');
      return;
    }
    if (password !== password2) {
      showInfo('两次输入的密码不一致');
      return;
    }
    if (showEmailVerification && (!email || !verification_code)) {
      showInfo('请填写邮箱并输入验证码');
      return;
    }

    setLoading(true);
    const res = await API.post(`/api/user/register`, inputs);
    const { success, message } = res.data;
    if (success) {
      navigate('/login');
      showSuccess('注册成功！');
    } else {
      showError(message);
    }
    setLoading(false);
  }

  const sendVerificationCode = async () => {
    if (inputs.email === '') {
      showInfo('请先输入邮箱地址');
      return;
    }
    setLoading(true);
    const res = await API.get(`/api/verification?email=${inputs.email}`);
    const { success, message } = res.data;
    if (success) {
      showSuccess('验证码发送成功，请检查你的邮箱！');
    } else {
      showError(message);
    }
    setLoading(false);
  };

  return (
    <div className='auth-shell'>
      <Segment className='auth-card'>
        <div className='auth-brand'>
          <span className='auth-brand-mark'>
            <Image src={logo} />
          </span>
          <div className='auth-brand-copy'>
            <div className='auth-brand-kicker'>{systemName}</div>
            <Header as='h2' className='auth-title'>
              创建账户
            </Header>
            <div className='auth-subtitle'>
              注册后即可获取令牌并开始调用模型。
            </div>
          </div>
        </div>

        <Form size='large' className='auth-form' onSubmit={handleSubmit}>
          <Segment className='auth-form-panel'>
            <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              label='用户名'
              placeholder='输入用户名，最长 12 位'
              onChange={handleChange}
              name='username'
              value={username}
            />
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              label='密码'
              placeholder='输入密码，最短 8 位，最长 20 位'
              onChange={handleChange}
              name='password'
              type='password'
              value={password}
            />
            <Form.Input
              fluid
              icon='check circle outline'
              iconPosition='left'
              label='确认密码'
              placeholder='再次输入密码'
              onChange={handleChange}
              name='password2'
              type='password'
              value={password2}
            />
            {showEmailVerification ? (
              <>
                <Form.Input
                  fluid
                  icon='mail'
                  iconPosition='left'
                  label='邮箱'
                  placeholder='输入邮箱地址'
                  onChange={handleChange}
                  name='email'
                  type='email'
                  value={email}
                  action={
                    <Button onClick={sendVerificationCode} disabled={loading} type='button'>
                      获取验证码
                    </Button>
                  }
                />
                <Form.Input
                  fluid
                  icon='shield alternate'
                  iconPosition='left'
                  label='验证码'
                  placeholder='输入邮箱验证码'
                  onChange={handleChange}
                  name='verification_code'
                  value={verification_code}
                />
              </>
            ) : (
              <></>
            )}
            <Form.Input
              fluid
              icon='ticket'
              iconPosition='left'
              label='邀请码'
              placeholder='选填'
              onChange={handleChange}
              name='aff_code'
              value={aff_code}
            />
            <Button
              primary
              fluid
              size='large'
              type='submit'
              className='auth-submit-button'
              loading={loading}
            >
              注册
            </Button>
          </Segment>
        </Form>

        <Message className='auth-helper-message'>
          <span>已有账户？</span>
          <Link to='/login' className='auth-helper-link'>
            点击登录
          </Link>
        </Message>

        <PolicyLinks />
      </Segment>
    </div>
  );
};

export default RegisterForm;
